import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import {
  REQUIRED_CNAME,
  WSP_SITE_EXTERNAL_IP,
  MULTISITE_EDITION_NAME,
  WSP_MS_SITE_EXTERNAL_IP,
  MS_CNAME,
} from '../../../globals';
import { AccountsService } from '../../accounts.service';
@Component({
  selector: 'app-domain-instruction-card',
  template: `
    <mat-card appearance="outlined" class="rightmost textalign-left">
      <mat-card-content class="card-regular">
        <div>
          <p style="margin-top:0">
            {{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.HEADER' | translate: { edition: editionName } }}
            <a
              class="plain-link accent-font"
              href="https://support.dnsimple.com/articles/differences-between-a-cname-alias-url/"
            >
              {{ 'BUTTONS.LEARN_MORE' | translate }}
            </a>
          </p>
          <div class="record-title">
            <span>{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.A_RECORD' | translate }}</span>
          </div>
          <div>
            <span class="card-bold">{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.NAME' | translate }}{{ ': ' }}</span>
            <span>{{ aRecordName }}</span>
          </div>
          <div class="record-value-spacing">
            <span class="card-bold">{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.VALUE' | translate }}{{ ': ' }}</span>
            <span>{{ aRecord }}</span>
            <button
              mat-icon-button
              matTooltip="{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.COPY_HOVER' | translate }}"
              color="primary"
              [cdkCopyToClipboard]="aRecord"
              (cdkCopyToClipboardCopied)="urlCopied()"
              class="domain-copy-button"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div>
            <span class="card-bold">{{ ttl }}{{ ': ' }}</span>
            <span>{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.TTL_VALUE' | translate }}</span>
          </div>
          <br />
          <div class="record-title">
            <span>{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.CNAME_RECORD' | translate }}</span>
          </div>
          <div>
            <span class="card-bold">{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.NAME' | translate }}{{ ': ' }}</span>
            <span>{{ cNameRecordName }}</span>
          </div>
          <div class="record-value-spacing">
            <span class="card-bold">{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.VALUE' | translate }}{{ ': ' }}</span>
            <span>{{ cnameRecord }}</span>
            <button
              mat-icon-button
              matTooltip="{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.COPY_HOVER' | translate }}"
              color="primary"
              [cdkCopyToClipboard]="cnameRecord"
              (cdkCopyToClipboardCopied)="urlCopied()"
              class="domain-copy-button"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div>
            <span class="card-bold">{{ ttl }}{{ ': ' }}</span>
            <span>{{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.TTL_VALUE' | translate }}</span>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions class="action-buttons">
        <a mat-button (click)="navigateHelp()" color="accent">
          {{ 'PAGES.DOMAINS.INSTRUCTIONS_MODAL.HOW_TO_CONNECT_DOMAIN' | translate }}
        </a>
      </mat-card-actions>
    </mat-card>
  `,
  styles: [
    `
      .action-buttons {
        text-align: right;
      }

      .card-regular {
        margin-bottom: -1em;
        font-weight: normal;
      }

      .card-bold {
        font-weight: bold;
      }

      .domain-copy-button {
        top: 7px;
      }

      .record-value-spacing {
        margin-top: -0.95em;
      }

      .record-title {
        font-size: large;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DomainInstructionComponent {
  cnameRecord = REQUIRED_CNAME;
  aRecord = WSP_SITE_EXTERNAL_IP;
  aRecordName = '@';
  cNameRecordName = 'www';
  ttl = 'TTL';
  editionName = 'Pro';

  constructor(
    private readonly snackbarService: SnackbarService,
    private accountsService: AccountsService,
  ) {
    this.accountsService.editionName$.subscribe((editionName: string) => {
      if (editionName == MULTISITE_EDITION_NAME) {
        this.aRecord = WSP_MS_SITE_EXTERNAL_IP;
        this.cnameRecord = MS_CNAME;
        this.editionName = MULTISITE_EDITION_NAME;
      }
    });
  }

  navigateHelp(): void {
    const url =
      'https://websitepro.zendesk.com/hc/en-us/articles/27654708694039-How-to-Connect-a-Custom-Domain-to-Website-Pro';
    window.open(url, '_blank');
  }

  urlCopied(): void {
    this.snackbarService.successSnack('PAGES.DOMAINS.INSTRUCTIONS_MODAL.COPY_POPUP');
  }
}
